import { Link, Route, Switch } from "react-router-dom";
import { FeesManager } from "./FeesManager";
import { SubscriptionEditor } from "./Editor";
import { SubscriptionList } from "./SubscriptionList";
import { CreateTieredUnitCountSubscriptionLink } from "./tiered-unit-count/CreateTieredUnitCountSubscriptionLink";
import SubscriptionForm from "./form/SubscriptionForm";

export const SubscriptionManagement = () => {
  return (
    <>
      <Switch>
        <Route path="/subscriptions/fees"><FeesManager /></Route>
        <Route path="/subscriptions/list"><SubscriptionList /></Route>
        <Route
          path={[
            "/subscriptions/tiered-unit-count/:subscriptionId",
            "/subscriptions/tiered-unit-count",
          ]}
          component={SubscriptionForm}
        />
        <Route
          path={[
            "/subscriptions/form/:subscriptionId",
            "/subscriptions/form",
          ]}
          component={SubscriptionForm}
        />
        <Route path="/subscriptions">
          <header className="Section-header">Subscription Management</header>
          <ul>
            <li><Link to="/subscriptions/fees">Fees</Link></li>
            <li><Link to="/subscriptions/list">Subscription List</Link></li>
            <br />
            <li><CreateTieredUnitCountSubscriptionLink /></li>
          </ul>
        </Route>
      </Switch >
    </>
  );
};
